import { render, staticRenderFns } from "./PopularFeatures.vue?vue&type=template&id=318cfad6&"
import script from "./PopularFeatures.vue?vue&type=script&lang=js&"
export * from "./PopularFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports